import { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import RowsIcon from "../../../../media/images/icons/rows-icons";

import TenderOfferCard from "./TenderOfferCard";
import { blueGrey } from "@mui/material/colors";
import { useAppDispatch } from "../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import { DotLoader } from "react-spinner-overlay";
import EmptyCargoSVG from "../../../../media/images/icons/empty-cargo";

export interface ITenderOffer {
  id: string;
  insertDate: string;
  updateDate: string;
  orderId: string;
  srcCode: number;
  srcName: string;
  destCode: number;
  destName: string;
  goodsCode: number;
  goodsName: string;
  companyCode: string;
  orderCode: number;
  price: number;
  queueNr: number;
  licenseNr: null;
  status: 1;
  driverFullName: string;
  driverNationalCode: string;
}

export default function () {
  const [hasScroll, setHasScroll] = useState(false);

  const theme = useTheme();

  const divRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  const [tendersList, setTendersList] = useState<ITenderOffer[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const { trigger: getTenderOfferList, isMutating: isgetTenderOfferMutting } =
    useSWRMutation(
      [`/DriverPriceReq/Search`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setTendersList(data.data);
        },
      }
    );

  useEffect(() => {
    getTenderOfferList({});
  }, []);

  const handleDeleteTender = (id: string) => {
    setTendersList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleEditPrice = (id: string, price: any) => {
    setTendersList((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            price,
          };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            مناقصه بار{" "}
          </Typography>
        }
        hasScroll={hasScroll}
      />

      <Box
        ref={divRef}
        sx={{
          flex: 1,
          overflow: "auto",
          paddingX: "8px",
          paddingY: "8px",
          paddingBottom: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            backgroundColor: "bgColor.white",
            padding: "16px",
            border: "1px solid",
            borderColor: blueGrey[100],
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <RowsIcon color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "18px",
              }}
            >
              پیشنهادات مناقصات بار{" "}
            </Typography>
          </Box>
          {/* <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          /> */}
        </Box>
        {/* <FilterSection /> */}

        {/* <CustomInput
          placHolder="جستجو بر اساس نام محموله..."
          endAdornment={<SearchSVG color={theme.palette.primary.main} />}
        /> */}
        {/* {sampleData.map((item) => (
          <TenderOfferCard key={item?.id} {...item} />
        ))} */}

        {!isgetTenderOfferMutting ? (
          tendersList.length ? (
            tendersList.map((item: ITenderOffer) => (
              <TenderOfferCard
                key={item?.id}
                {...item}
                // handleDeleteTender={handleDeleteTender}
                // handleEditPrice={handleEditPrice}
              />
            ))
          ) : (
            <Box
              sx={{
                width: "100%",
                flex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  height: "200px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "16px",
                }}
              >
                <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
                <Typography
                  maxWidth={150}
                  textAlign={"center"}
                  sx={{
                    fontWeight: "700",
                    color: blueGrey[500],
                  }}
                >
                  درحال حاضر مناقصه‌ای برای نمایش وجود ندارد!
                </Typography>
              </Box>
            </Box>
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              flex: "1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <DotLoader color={theme.palette.primary.main} />
              <Typography>لطفا منتظر باشید...</Typography>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}
